import styled from 'styled-components';

export const Container = styled.div`
  &.page-container {
    padding: 0;
    min-height: calc(100vh - 56px);
    display: flex;
    flex-direction: column;
  }

  .academy-topbar {
    padding-top: 16px;
    flex-shrink: 0;
  }

  .academy-heading {
    font-size: 1.25rem;
    font-weight: 600;
    color: #212529;
    margin: 24px 0px;
  }

  .academy-tabs {
    display: flex;
    align-items: flex-end;
    gap: 4px;
  }

  .tabs-right {
    margin-left: auto;
  }

  .academy-tab {
    display: flex;
    align-items: end;
    gap: 6px;
    padding: 10px 18px;
    background: transparent;
    border: none;
    color: #6c757d;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    border-radius: 6px 6px 0 0;
    line-height: 1;

    &.ao-vivo {
      align-items: center;
    }
  }

  .academy-tab .material-icons {
    font-size: 18px;
    line-height: 1;
    display: block;
  }

  .academy-tab-icon {
    width: 18px;
    height: 18px;
    display: block;
  }

  .academy-tab:not(:disabled):hover {
    color: #21354a;
  }

  .academy-tab.active {
    background: #fff;
    color: #21354a;
  }

  .academy-tab.active .material-icons {
    color: #21354a;
  }

  .academy-tab.blocked {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .ao-vivo-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #dc3545;
    flex-shrink: 0;
    animation: academy-live-pulse 1.2s infinite;
  }

  @keyframes academy-live-pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
    }
    70% {
      box-shadow: 0 0 0 6px rgba(220, 53, 69, 0);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
    }
  }

  .academy-content {
    background: #fff;
    flex: 1 1 auto;
    padding: 22px 0 40px;
  }

  @media (max-width: 768px) {
    .academy-tabs {
      flex-wrap: wrap;
    }

    .tabs-right {
      margin-left: 0;
    }

    .academy-tab {
      padding: 8px 12px;
      font-size: 0.85rem;
    }
  }
`;
